import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage } from 'react-intl';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { RootState } from '../../reducers';
import './Page404.scss';
import * as actions from '../../actions/index';

interface Props {
  history: any;
  isLoading: boolean;
  location: any;
  actions: any;
  intl: any;
}

const Page404 = (props: Props) => {
  useEffect(() => {
    document.documentElement.classList.add('notFound');

    return () => {
      document.documentElement.classList.remove('notFound');
    };
  }, []);

  return (
    <div className='container-fluid journey1 p-0'>
      <div>
        <div className='pageContainer page404'>
          <FormattedMessage id='ec.navigation.pageDoesNotExist' defaultMessage='Die Seite existiert nicht' />
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    actions: bindActionCreators(actions as any, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Page404);
